import React, { useState } from 'react'
import { Modal, Button, Form, Message } from 'semantic-ui-react'

export default function CouponModal({ open, onClose, onRedeem, autoCoupon }) {
    const [coupon, setCoupon] = useState(autoCoupon || '')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [success, setSuccess] = useState('')

    const handleRedeem = async () => {
        setLoading(true)
        setError('')
        setSuccess('')
        try {
            const result = await onRedeem(coupon)
            if (result.success) {
                setSuccess(
                    'Coupon applied! 4000 free credits have been added to your account.'
                )
            } else {
                setError(result.message || 'Invalid coupon code.')
            }
        } catch (e) {
            setError('An error occurred. Please try again.')
        }
        setLoading(false)
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            size="tiny"
            closeOnDimmerClick={!loading}
        >
            <Modal.Header>Limited-time Offer!</Modal.Header>
            <Modal.Content>
                <p>
                    Enter your coupon code to receive 4000 free credits!
                    Limited-time offer.
                </p>
                <Form onSubmit={handleRedeem} loading={loading}>
                    <Form.Input
                        placeholder="Enter coupon code"
                        value={coupon}
                        onChange={(e) => setCoupon(e.target.value)}
                        disabled={!!autoCoupon}
                    />
                    {/* Show error and success messages above the form input */}
                    {error && (
                        <Message
                            error
                            content={error}
                            style={{ display: 'block' }}
                        />
                    )}
                    {success && (
                        <Message
                            success
                            content={success}
                            style={{ display: 'block' }}
                        />
                    )}
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose} disabled={loading || !!success}>
                    {'Skip'}
                </Button>
                <Button
                    color="teal"
                    onClick={handleRedeem}
                    loading={loading}
                    disabled={!coupon}
                >
                    {success ? 'Close' : 'Submit'}
                </Button>
            </Modal.Actions>
        </Modal>
    )
}